import React from "react";
import { CircleAlert, TriangleAlert } from "lucide-react";

const TONES = {
  problem: { Icon: CircleAlert, box: "border-danger_border bg-danger_bg", icon: "text-danger" },
  warning: { Icon: TriangleAlert, box: "border-warning_border bg-warning_bg", icon: "text-warning" },
};

// Publish problems (tone "problem") or warnings, one line each.
export default function MessageList({ items, tone = "problem" }) {
  if (!items?.length) return null;
  const { Icon, box, icon } = TONES[tone] || TONES.problem;
  return (
    <ul className={`space-y-1.5 rounded-lg border px-3 py-2.5 ${box}`}>
      {items.map((item, index) => (
        <li key={index} className="flex items-start gap-2 text-xs text-text_primary">
          <Icon size={14} className={`mt-px shrink-0 ${icon}`} aria-hidden="true" />
          <span className="break-words">{item}</span>
        </li>
      ))}
    </ul>
  );
}
